<script setup lang="ts">
import { shallowRef, computed } from 'vue'

import type { Form } from '@/services/form'
import type { AppType, CanvasOptions, RulesSet } from '=/types'

import stack from '@/assets/images/bonds/stack.svg?raw'
import stretcher from '@/assets/images/bonds/stretcher.svg?raw'
import wild from '@/assets/images/bonds/wild.svg?raw'

const values = defineModel<Form<CanvasOptions>>('values', { required: true })

const props = defineProps<{ rules?: RulesSet; app: AppType }>()

const bondsMap = shallowRef<Record<string, string>>({
  stack,
  stretcher,
  wild
})

const orientationMap: Record<string, string> = {
  horizontal: props.app.lang.bonds.orientations.types.horizontal,
  vertical: props.app.lang.bonds.orientations.types.vertical
}

const orientation = computed(() => values.value.form.value.bond.orientation.options.length > 1)
</script>

<template>
  <p class="config__text">{{ app.lang.bonds.description }}</p>
  <ul class="config__grid open three meta">
    <template v-for="(bond, index) in rules?.bonds" :key="index">
      <li>
        <label class="item">
          <span v-if="bond.explicit" class="item__label">{{ app.lang.bonds.recommended }}</span>
          <input type="radio" :name="bond.name" :value="bond" v-model="values.form.value.bond" :checked="values.form.value.bond.name === bond.name" />
          <svg v-html="bondsMap[bond.name]"></svg>
        </label>
      </li>
    </template>
  </ul>
  <template v-if="orientation">
    <div class="config__form two margin-top orientation">
      <p class="title">{{ app.lang.bonds.orientations.title }}</p>
      <template v-for="(orientation, index) in values.form.value.bond.orientation.options" :key="index">
        <label class="select">
          <input type="radio" name="orientatie" :value="orientation" v-model="values.form.value.bond.orientation.default" />
          {{ orientationMap[orientation] }}
        </label>
      </template>
    </div>
  </template>
</template>

<style scoped>
.select {
  text-transform: capitalize;
}
</style>
